import {
  defaultShouldDehydrateQuery,
  QueryClient,
} from "@tanstack/react-query";
import SuperJSON from "superjson";

export function createQueryClient() {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 1000 * 60 * 60, // 1 hour
        gcTime: 1000 * 60 * 60 * 24, // 24 hours
        refetchOnWindowFocus: false,
        refetchOnMount: true,
        retry: false,
      },
      dehydrate: {
        serializeData: SuperJSON.serialize,
        shouldDehydrateQuery: (query) =>
          defaultShouldDehydrateQuery(query) ||
          query.state.status === "pending",
      },
      hydrate: { deserializeData: SuperJSON.deserialize },
    },
  });

  // if (typeof window !== "undefined") {
  //   const persister = createSyncStoragePersister({
  //     storage: window.localStorage,
  //     serialize: SuperJSON.stringify,
  //     deserialize: SuperJSON.parse,
  //   });

  //   void persistQueryClient({
  //     queryClient,
  //     persister,
  //     // maxAge: 1000 * 60 * 60 * 24, // 24 hours
  //     maxAge: Number.MAX_SAFE_INTEGER,
  //     hydrateOptions: {
  //       defaultOptions: {
  //         queries: {
  //           gcTime: 1000 * 60 * 60 * 24,
  //         },
  //       },
  //     },
  //   });
  // }

  return queryClient;
}
